import { topicEntries } from "@/mocks/homeData";

export default function TopicEntries() {
  return (
    <section id="topics" className="bg-background-50 py-14 md:py-24">
      <div className="px-4 md:px-10 max-w-6xl mx-auto">
        <div className="text-center max-w-2xl mx-auto">
          <span className="text-accent-700 text-xs md:text-sm tracking-[0.2em] uppercase">
            TOPIC · ENTRY
          </span>
          <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            话题入口 · 挑一个围观
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
            按题材分好的入口，点进去就是对应那一类专业吃瓜现场，热帖更新时也会优先挂在这些入口下面。
          </p>
        </div>

        <div className="mt-10 md:mt-12 grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
          {topicEntries.map((topic) => (
            <a
              key={topic.name}
              href="#topics"
              className="group rounded-lg border border-background-200 bg-background-100 hover:border-accent-300 hover:bg-accent-50 p-4 md:p-5 flex flex-col gap-3 cursor-pointer transition-colors"
            >
              <span className="w-11 h-11 rounded-md bg-background-50 flex items-center justify-center text-primary-600 group-hover:bg-accent-100 group-hover:text-accent-700 transition-colors">
                <i className={`${topic.icon} text-xl`}></i>
              </span>
              <span className="min-w-0">
                <span className="block text-sm md:text-base font-medium text-foreground-950 truncate">
                  {topic.name}
                </span>
                <span className="block mt-1 text-xs text-foreground-500">
                  {topic.count}
                </span>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}